import { render, staticRenderFns } from "./Enfermera.vue?vue&type=template&id=35861948"
import script from "./Enfermera.vue?vue&type=script&lang=js"
export * from "./Enfermera.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports